module.exports = __webpack_public_path__ + "media/summer_tipping_tier_3-3788096f2b606995f4f79abbfb3698db.mp3";